import { createElement } from 'react';
import { string, number } from 'prop-types';
import { sizePropType } from '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _ProgressBar, { ProgressBarIndicator } from './styled.js';

function normalizeValue(value, maxValue) {
  var newValue = value;
  if (newValue > maxValue) newValue = maxValue;else if (newValue < 0) newValue = 0;
  return newValue;
}

var ProgressBar = function ProgressBar(_ref) {
  var maxValue = _ref.maxValue,
      size = _ref.size,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["maxValue", "size", "value"]);

  var newValue = value || 0;
  var newMaxValue = maxValue || 100;
  newValue = normalizeValue(newValue, newMaxValue);
  var percent = newValue / newMaxValue * 100;
  return (// @ts-ignore
    createElement(_ProgressBar, _extends({
      role: "progressbar",
      "aria-valuenow": newValue,
      "aria-valuemin": 0,
      "aria-valuemax": newMaxValue,
      styledSize: size
    }, props), createElement(ProgressBarIndicator, {
      color: props.color,
      value: percent
    }))
  );
};
var progressBarPropTypes = {
  color: string,
  maxValue: number,
  size: sizePropType,
  value: number
};
ProgressBar.propTypes = progressBarPropTypes;
var progressBarDefaultProps = {
  color: 'primary',
  maxValue: 100,
  size: 'default',
  value: 0
};
ProgressBar.defaultProps = progressBarDefaultProps; // @ts-ignore

var C = ProgressBar;

export default C;
export { C as ProgressBar, progressBarDefaultProps, progressBarPropTypes };
